import { STATUS } from "../constants/hospital.contants";
import CryptoJS from "crypto-js";
 export const BASE_URL = "https://sottokarnatakaapi.convenientcare.life/";
//export const BASE_URL = "https://api.jeevasarthakathe.karnataka.gov.in/";
export const PAYMENT_LINK =
  "https://www.onlinesbi.com/sbicollect/icollecthome.htm?corpID=959165";
export const PAYMENT_URL =
  "https://test.epay.sbiuat.bank.in/secure/AggregatorHostedListener";

export const RECIEPIENT_MASTER_TYPE = 3;
export const RECIEPIENT_MEDICAL_DETAILS_MASTER_TYPE = 5;
export const RECIEPIENT_DECLARATION_MASTER_TYPE = 8;
export const DONOR_MASTER_TYPE = 4;
export const CONSENT_MASTER_TYPE = 6;
export const DONOR_LEGAL_MASTER_TYPE = 7;
export const HEART_ID = "106";
export const LIVER_ID = "103";
export const SPLIT_LIVER_1_ID = "104";
export const SPLIT_LIVER_2_ID = "105";
export const LUNG_ID = "107";
export const LEFT_LUNG_ID = "108";
export const RIGHT_LUNG_ID = "109";
export const KIDNEY_ID = "100";
export const KIDNEY_LEFT_ID = "101";
export const KIDNEY_RIGHT_ID = "102";
export const PANCREAS_ID = "111";
export const HEART_LUNG_ID = "110";
export const BLOOD_GROUP_VALUES = {
  A: [13, 14],
  B: [15, 16],
  AB: [17, 18],
  O: [19, 20],
};
const moment = require("moment-timezone");
export function getDate() {
  return moment().format("YYYY-MM-DDTHH:mm:ss");
}
export function getDateOnly() {
  return moment().format("YYYY-MM-DD");
}
export function formatTable(date) {
  if (!date) return "";
  return moment(date).format("Do MMM YYYY");
}
export function sleep(sec) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), sec);
  });
}
export function isObject(item) {
  return item instanceof Object == true;
}
export function isDocObject(item) {
  return item && item[0] instanceof Object == true;
}
export function isArray(item) {
  return item instanceof Array == true;
}
export function encode(id) {
  let key = "purushothaman";
  id = CryptoJS.AES.encrypt(id.toString(), key).toString();
  return encodeURIComponent(id);
}
export function encrypt(id) {
  var key = CryptoJS.enc.Utf8.parse("Mocero1234567890");
  var iv = CryptoJS.enc.Utf8.parse("Mocero1234567890");
  var encryptedlogin = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(id), key, {
    keySize: key,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

  return encryptedlogin;
}
export function decode(id) {
  let key = "purushothaman";
  id = decodeURIComponent(id);
  return CryptoJS.AES.decrypt(id, key).toString(CryptoJS.enc.Utf8);
}
// Inverse of encrypt() above — used to decode PII fields (email_id, phone_number_1)
// that the API now returns AES-encrypted instead of asterisk-masked (VAPT W2).
// Returns the original cipher text if decryption fails so the UI never blows up.
export function decrypt(cipherText) {
  if (!cipherText) return cipherText;
  try {
    var key = CryptoJS.enc.Utf8.parse("Mocero1234567890");
    var iv = CryptoJS.enc.Utf8.parse("Mocero1234567890");
    var decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    var plain = decrypted.toString(CryptoJS.enc.Utf8);
    return plain || cipherText;
  } catch (e) {
    return cipherText;
  }
}
export function formatDate(date) {
  if (date) return moment(date).local().format("DD/MM/YY HH:mm");
  return "";
}
export function formatDateOnly(date) {
  if (date) return moment(date).format("DD/MM/YYYY");
  return "";
}
export function getStart(date) {
  return moment(date).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
}
export function getEnd(date) {
  return moment(date).endOf("day").format("YYYY-MM-DDTHH:mm:ss");
}
export function getRawDate() {
  return moment();
}

export function getSelect(list) {
  let items = [];
  if (list) {
    items = list.filter((item) => {
      if (item !== "All") return { name: item, value: item };
    });
  }
  items.unshift({ name: "Please select", value: "" });
  return items;
}
export function getDynamicSelect(list) {
  let items = [];
  if (list) {
    items = list.map((item) => {
      return { name: item.name, value: item.id };
    });
  }
  items.unshift({ name: "Please select", value: "" });
  return items;
}
export function openFile(url) {
  url = BASE_URL + url;
  window.open(url, "_blank").focus();
}
export function chatLink(url) {
  url = BASE_URL + url;
  return url;
}
export function getStatus(s) {
  let status = STATUS[s];
  return status != null ? status : STATUS[1];
}

export function getDocObject(obj, doc) {
  if (doc == undefined) doc = {};
  Object.keys(obj).forEach((key) => {
    doc[key] = obj[key];
  });
  return doc;
}
export function getAge(DOB) {
  if (!DOB) return "";
  var ageDifMs = Date.now() - new Date(DOB);
  var ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}
export const NOT_ALLOWED_FOR_HOSPITAL = ["/masters", "/sotto-management"];
export const NOT_ALLOWED_FOR_SUBADMIN = ["/masters"];
export const NOT_ALLOWED_FOR_MASTER = ["/manage-alf-approver"];
export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

// SBI ePay Payment - POST EncryptTrans and merchIdVal to SBI ePay gateway
// Shows a no-refund disclaimer first; user must explicitly acknowledge before redirect.
export const initPayment = (json) => {
  let $ = window.$;

  // Debug logging - log what we're sending to SBI
  console.log("=== SBI ePay Payment Debug ===");
  console.log("PAYMENT_URL:", PAYMENT_URL);
  console.log("merchIdVal:", json.merchId);
  console.log("encryptedTrans:", json.encryptedTrans);
  console.log("encryptedTrans length:", json.encryptedTrans ? json.encryptedTrans.length : 0);
  console.log("Full API response:", JSON.stringify(json, null, 2));
  console.log("==============================");

  const submitToSBI = () => {
    let list = [
      $("<input>", {
        type: "hidden",
        name: "EncryptTrans",
        value: json.encryptedTrans,
      }),
      $("<input>", {
        type: "hidden",
        name: "merchIdVal",
        value: json.merchId,
      }),
    ];

    $("<form/>", {
      action: PAYMENT_URL,
      method: "POST",
    })
      .append(list)
      .appendTo("body")
      .submit();
  };

  showPaymentDisclaimer(submitToSBI);
};

// Renders a bootstrap-styled modal that forces the user to acknowledge the
// "no refund after successful payment" disclaimer before SBI ePay is invoked.
// Calls onProceed() if the user accepts; closes silently if they cancel.
export const showPaymentDisclaimer = (onProceed) => {
  let $ = window.$;
  const modalId = "sotto-payment-disclaimer-modal";
  // If the modal already exists from a previous trigger, remove it
  $("#" + modalId).remove();
  $(".modal-backdrop").remove();

  const html = `
    <div class="modal fade show" id="${modalId}" tabindex="-1" role="dialog"
         style="display:block; background:rgba(0,0,0,0.55); z-index:10500;">
      <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:560px;">
        <div class="modal-content" style="border:none; border-radius:8px; box-shadow:0 10px 40px rgba(0,0,0,0.25);">
          <div class="modal-header" style="background:#dc3545; color:#fff; border-radius:8px 8px 0 0;">
            <h5 class="modal-title" style="font-weight:600;">
              <i class="fa fa-exclamation-triangle"></i>&nbsp;Important: Please Read Before Proceeding
            </h5>
          </div>
          <div class="modal-body" style="padding:24px; font-size:15px; color:#222; line-height:1.55;">
            <p style="margin-bottom:14px;">
              You are about to be redirected to the <strong>SBI ePay payment gateway</strong>
              to complete your transaction.
            </p>
            <div style="background:#fff3cd; border-left:4px solid #ffc107; padding:12px 14px; margin-bottom:14px;">
              <strong style="color:#856404;">DISCLAIMER &mdash; NO REFUND POLICY</strong><br/>
              <span style="color:#5c4609;">
                Once payment is successfully completed, the amount paid is
                <strong>non-refundable</strong> under any circumstances. Please verify all details
                carefully before proceeding. By clicking <em>Proceed to Pay</em> below, you
                acknowledge and accept that no refund will be issued for a successful transaction.
              </span>
            </div>
            <div class="form-check" style="margin-bottom:4px;">
              <input class="form-check-input" type="checkbox" id="sotto-pay-ack" />
              <label class="form-check-label" for="sotto-pay-ack" style="user-select:none; cursor:pointer;">
                I have read and understood the no-refund policy and wish to proceed.
              </label>
            </div>
          </div>
          <div class="modal-footer" style="border-top:1px solid #eee;">
            <button type="button" class="btn btn-secondary" id="sotto-pay-cancel">Cancel</button>
            <button type="button" class="btn btn-danger" id="sotto-pay-proceed" disabled>
              Proceed to Pay
            </button>
          </div>
        </div>
      </div>
    </div>
  `;

  $("body").append(html);
  $("body").css("overflow", "hidden");

  const cleanup = () => {
    $("#" + modalId).remove();
    $("body").css("overflow", "");
  };

  $("#sotto-pay-ack").on("change", function () {
    $("#sotto-pay-proceed").prop("disabled", !this.checked);
  });

  $("#sotto-pay-cancel").on("click", function () {
    cleanup();
  });

  $("#sotto-pay-proceed").on("click", function () {
    cleanup();
    if (typeof onProceed === "function") {
      onProceed();
    }
  });
};
